import React from 'react';
import { Container } from 'semantic-ui-react';

const PageContainer = props => (
  <Container {...props} style={{ marginTop: '25px' }} />
);

export default PageContainer;
